import { checkUserRoles, useAuth } from '../contexts/auth';
import { resetState } from '../redux';
export const useJaenUpdate = () => {
    const auth = useAuth();
    const key = 'ljch';
    const latestWebpackCompilationHash = __JAEN_DATA_CONTENT_DIGEST__;
    const isDisabled = latestWebpackCompilationHash === undefined;
    const isJaenUpdate = () => {
        if (typeof window === 'undefined') {
            return false;
        }
        const latestJaenCompilationHash = localStorage.getItem(key);
        if (latestWebpackCompilationHash &&
            latestJaenCompilationHash !== null &&
            latestWebpackCompilationHash !== latestJaenCompilationHash) {
            return true;
        }
        if (latestWebpackCompilationHash) {
            const isJaenAdmin = checkUserRoles(auth.user, ['jaen:admin']);
            if (isJaenAdmin) {
                localStorage.setItem(key, latestWebpackCompilationHash);
            }
        }
        return false;
    };
    const updateToLatest = () => {
        resetState();
        localStorage.removeItem(key);
    };
    return {
        isJaenUpdate: isJaenUpdate(),
        isDisabled,
        updateToLatest
    };
};
